/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiPurewaveSettingRadioQueryResponse, GetApiPurewaveSettingRadio400, GetApiPurewaveSettingRadio401, GetApiPurewaveSettingRadio403, GetApiPurewaveSettingRadio500 } from "../../types/GetApiPurewaveSettingRadio.ts";
import { getApiPurewaveSettingRadioQueryResponseSchema } from "../../zod/PureWaveSettingSchemas/getApiPurewaveSettingRadioSchema.ts";

function getGetApiPurewaveSettingRadioUrl() {
  const res = { method: 'GET', url: `/api/purewave-setting/radio` as const }  
  return res
}

/**
 * @summary Получить текущее состояние радио
 * {@link /api/purewave-setting/radio}
 */
export async function getApiPurewaveSettingRadio(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiPurewaveSettingRadioQueryResponse, ResponseErrorConfig<GetApiPurewaveSettingRadio400 | GetApiPurewaveSettingRadio401 | GetApiPurewaveSettingRadio403 | GetApiPurewaveSettingRadio500>, unknown>({ method : "GET", url : getGetApiPurewaveSettingRadioUrl().url.toString(), ... requestConfig })  
  return getApiPurewaveSettingRadioQueryResponseSchema.parse(res.data)
}